"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecentlyViewedContextProvider = exports.useRecentlyViewedProducts = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var RecentlyViewedContext = /*#__PURE__*/_react["default"].createContext();
var RecentlyViewedContextProvider = function RecentlyViewedContextProvider(props) {
  var _useState = (0, _react.useState)(null),
    product = _useState[0],
    setProduct = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    recentlyViewedProducts = _useState2[0],
    setRecentlyViewedProducts = _useState2[1];
  var isFirstRun = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      var recentlyViewedProductsStorage = localStorage.getItem("recentlyViewedProducts");
      setRecentlyViewedProducts(recentlyViewedProductsStorage ? JSON.parse(recentlyViewedProductsStorage) : []);
      return;
    }
    if (product && !recentlyViewedProducts.find(function (prod) {
      return prod.sku === product.sku;
    })) {
      var products = [product].concat((0, _toConsumableArray2["default"])(recentlyViewedProducts.slice(0, 5)));
      setRecentlyViewedProducts(products);
      localStorage.setItem("recentlyViewedProducts", JSON.stringify(products));
    }
  }, [product]);
  return __jsx(RecentlyViewedContext.Provider, {
    value: {
      recentlyViewedProducts: recentlyViewedProducts,
      setProduct: setProduct,
      product: product
    }
  }, props.children);
};
exports.RecentlyViewedContextProvider = RecentlyViewedContextProvider;
var useRecentlyViewedProducts = function useRecentlyViewedProducts(product) {
  var _useContext = (0, _react.useContext)(RecentlyViewedContext),
    setProduct = _useContext.setProduct,
    recentlyViewedProducts = _useContext.recentlyViewedProducts,
    lastAddedProduct = _useContext.product;
  (0, _react.useEffect)(function () {
    if (product) {
      setProduct(product);
    }
  }, []);
  return recentlyViewedProducts && lastAddedProduct ? recentlyViewedProducts.filter(function (prod) {
    return prod.sku !== lastAddedProduct.sku;
  }) : recentlyViewedProducts;
};
exports.useRecentlyViewedProducts = useRecentlyViewedProducts;